import { useEffect, useRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { ReactComponent as UGGLogo } from "@ugg/shared/assets/svg/logos/ugg-logo-blue.svg";
import { SvgGameVal } from "@ugitgud/legos/ui/icon/SVG/GameVal";
import { SvgGameLol } from "@ugitgud/legos/ui/icon/SVG/GameLol";
import { ReactComponent as RightArrowHead } from "svg/right-arrow-head.svg";

function useVideoLoop(videoRef: HTMLVideoElement | null, loops: number) {
  const currLoops = useRef(1);

  useEffect(() => {
    function endedHandler() {
      if (videoRef && currLoops.current < loops) {
        videoRef.play();
        currLoops.current++;
      }
    }
    videoRef?.addEventListener("ended", endedHandler);

    return () => {
      videoRef?.removeEventListener("ended", endedHandler);
    };
  }, [videoRef, loops]);
}

export function WowPromo(props: { className?: string }) {
  return (
    <div className={classnames("builds-page-promo", props.className)}>
      <div className="holder">
        <div className="promo-header">
          <img src="/images/ugg/games/WoW-detailed-icon.png" width={20} />
          <div className="flex item-center ml-[10px] h-[20px]">
            <UGGLogo className="w-[50px]" />
          </div>
          <span className="relative ml-[7px] top-[1px]">has WoW</span>
        </div>
        <div className="text-box">
          Data Driven.
          <br />
          Always Best in Slot.
        </div>
        <a
          className="link-button bg-accent-blue-400 hover:bg-accent-blue-600"
          href="https://u.gg/wow/tier-list/dps-rankings/raid?utm_source=UGG&utm_campaign=BuildPage"
        >
          Check it Out
          <div className="arrow-holder">
            <RightArrowHead style={{ height: "16px", width: "16px" }} />
          </div>
        </a>
      </div>
      <video autoPlay loop muted className="promo-background">
        <source type="video/webm" src="https://static.bigbrain.gg/assets/ugg/pages/champion/wowbgloop.webm" />
      </video>
      <div className="overlay" />
    </div>
  );
}

export function ValorantAppPromo(props: { className?: string }) {
  return (
    <div className={classnames("builds-page-promo bg-purple-400", props.className)}>
      <div className="holder">
        <div className="promo-header">
          <SvgGameVal className="w-[20px]" />
          <div className="flex item-center ml-[10px] h-[20px]">
            <UGGLogo className="w-[50px]" />
          </div>
          <span className="relative ml-[7px] top-[1px]">Valorant App</span>
          <div className="relative top-[1px] flex items-center ml-[5px] px-[4px] h-[14px] rounded-[1px] bg-accent-forest-green-500 font-bold text-[10px]">
            BETA
          </div>
        </div>
        <div className="text-box">
          Peek Maps,
          <br />
          Scouting & More
        </div>
        <a
          className="link-button bg-accent-blue-400 hover:bg-accent-blue-600"
          href="https://u.gg/val/app?utm_source=UGG&utm_campaign=BuildPage"
        >
          Download Now
          <div className="arrow-holder">
            <RightArrowHead style={{ height: "16px", width: "16px" }} />
          </div>
        </a>
      </div>
      <video autoPlay loop muted className="promo-background ml-[73px]">
        <source type="video/webm" src="https://static.bigbrain.gg/assets/ugg/pages/champion/valorant-app-promo.webm" />
      </video>
      <div className="overlay left-[73px]" />
    </div>
  );
}

export function LoLAppPromo(props: { className?: string }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  useVideoLoop(videoRef.current, 3);

  return (
    <div className={classnames("builds-page-promo bg-purple-400 max-h-[262px]", props.className)}>
      <div className="holder pt-[24px] pb-[18px]">
        <div className="promo-header">
          <SvgGameLol className="w-[20px]" />
          <div className="flex item-center ml-[10px] h-[20px]">
            <UGGLogo className="w-[50px]" />
          </div>
          <span className="relative ml-[7px] top-[1px]">Desktop App</span>
        </div>
        <div className="text-box">
          Never set runes again.
          <br />
          Auto-import runes,
          <br />
          items and skill order.
        </div>
        <Link
          className="link-button mt-auto bg-accent-red-500 hover:bg-accent-red-700"
          to="/app?utm_source=UGG&utm_campaign=BuildPage"
        >
          Download App
          <div className="arrow-holder">
            <RightArrowHead style={{ height: "16px", width: "16px" }} />
          </div>
        </Link>
      </div>
      <video ref={videoRef} autoPlay muted className="promo-background ml-[73px]">
        <source type="video/webm" src="https://static.bigbrain.gg/assets/ugg/pages/desktop-app/ugg-app-landing.webm" />
      </video>
      <div className="overlay left-[73px]" />
    </div>
  );
}
